import subsidiaryClaimService from '@rd-web-markets/shared/dist/services/claim/subsidiary_claim.service';
import React, { useCallback, useState } from 'react';
import TotalCostData from './TotalCostData';
import { Tab, Tabs } from 'react-bootstrap';
export default function TotalCostTabs(_ref) {
  var _claim$company;
  let {
    claim,
    setClaim,
    saveClaim
  } = _ref;
  const [key, setKey] = useState('claim');
  const {
    subsidiaryClaims,
    updateSubsidiaryClaimState,
    updateSubsidiaryClaim
  } = subsidiaryClaimService.useCrud({
    claimId: claim.id
  });
  const getSelectedSubsidiaryClaim = selectedTabKey => {
    const subsidiaryClaim = subsidiaryClaims === null || subsidiaryClaims === void 0 ? void 0 : subsidiaryClaims.find(sc => sc.id.toString() === selectedTabKey);
    return subsidiaryClaim;
  };
  return /*#__PURE__*/React.createElement(Tabs, {
    activeKey: key,
    onSelect: k => setKey(k),
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "claim",
    title: "Claim"
  }, key === 'claim' && /*#__PURE__*/React.createElement(TotalCostData, {
    claim: claim,
    setClaim: setClaim,
    saveClaim: saveClaim
  })), ((_claim$company = claim.company) === null || _claim$company === void 0 ? void 0 : _claim$company.has_subsidiary_companies) && (subsidiaryClaims === null || subsidiaryClaims === void 0 ? void 0 : subsidiaryClaims.map(subsidiaryClaim => {
    var _subsidiaryClaim$subs;
    return /*#__PURE__*/React.createElement(Tab, {
      key: subsidiaryClaim.id,
      eventKey: subsidiaryClaim.id.toString(),
      title: ((_subsidiaryClaim$subs = subsidiaryClaim.subsidiary_company) === null || _subsidiaryClaim$subs === void 0 ? void 0 : _subsidiaryClaim$subs.name) || "Subsidiary ".concat(subsidiaryClaim.id)
    }, key !== 'claim' && /*#__PURE__*/React.createElement(TotalCostData, {
      claim: getSelectedSubsidiaryClaim(key),
      setClaim: updateSubsidiaryClaimState,
      saveClaim: updateSubsidiaryClaim
    }));
  })));
}